var map = {
	"./pin.png": 7245,
	"./pin1.png": 3542,
	"./pin2.png": 2867,
	"./pin3.png": 7009,
	"./pin4.png": 6935,
	"./pin5.png": 1228,
	"./pin6.png": 2758,
	"./pin7.png": 9332,
	"./pin8.png": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9289;